$(function () {

    $(document).on('click', '.business_button',
        function (e) {
            $('.js-options-loader').fadeIn();
            var form = $("#compare_form");
            $.ajax(
                {
                    url: form.attr('action'),
                    data: form.serialize() + "&PricingType=Business",
                    type: "POST",
                    success: function (data) {
                        $('.business_button').removeClass('btn-filter-inactive').addClass('is-active');
                        $('.personal_button').removeClass('is-active').addClass('btn-filter-inactive');
                        $("#vehicle-results").html(data);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('click', '.personal_button',
        function (e) {
            $('.js-options-loader').fadeIn();
            var form = $("#compare_form");
            $.ajax(
                {
                    url: form.attr('action'),
                    data: form.serialize() + "&PricingType=Personal",
                    type: "POST",
                    success: function (data) {
                        $('.personal_button').removeClass('btn-filter-inactive').addClass('is-active');
                        $('.business_button').removeClass('is-active').addClass('btn-filter-inactive');
                        $("#vehicle-results").html(data);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('click', '.btn.btn-filter.vt-cookie',
        function (e) {
            $('.js-options-loader').fadeIn();
            var form = $("#compare_form");
            var searchForm = $('.vehicle-search__compare');
            var thisButton = $(this);
            $.ajax(
                {
                    url: form.attr('action'),
                    data: "?VehicleType=" + thisButton.text(),
                    type: "POST",
                    success: function (data) {
                        thisButton.removeClass('btn-filter-inactive');
                        thisButton.siblings().addClass('btn-filter-inactive');
                        $("#vehicle-results").html(data);

                        var cookiename = "compCar";
                        $('input[id=IsCar]').val('True');
                        if (cookies.get("vt") === "Vans") {
                            $('input[id=IsCar]').val('False');
                            cookiename = "compVan";
                        }
                        var value = cookies.get(cookiename) !== undefined ? cookies.get(cookiename).replace(",,", ",").replace(/^,+|,+&/, "").replace(/,+$/, "").trim() : null;
                        var splitValue = value !== null && value !== undefined ? value.split(",").filter(Boolean).length : 0;
                        if (splitValue < 4) {
                            $('#vehicle-card-container-search').show();
                        } else {
                            $('#vehicle-card-container-search').hide();
                        }
                        if (splitValue < 1) {
                            $('.col-lg-pull-8').hide();
                            $('.col-lg-push-8').hide();
                        } else {
                            $('.col-lg-pull-8').show();
                            $('.col-lg-push-8').show();
                        }

                        $.post(searchForm.data("filterroute"), searchForm.serialize(), function (response) {
                            var umbRouting = searchForm.find("input[name=ufprt]").clone();
                            searchForm.html(response).append(umbRouting);
                            searchForm.find('.selectpicker').selectpicker('refresh');
                        });

                        $('.js-options-loader').fadeOut();
                    }
                });
        });


    function updateVehicleSpecHeight() {
        var height = 0;

        $('.vehicle').each(function () {

            var techDetailsHeight = $(this).find('.vehicle__technical-data').outerHeight();
            if (height < techDetailsHeight)
                height = techDetailsHeight;
        });

        if (Modernizr.mq('(min-width: 768px)'))
            $('.vehicle__technical-data').css('height', height);
        else
            $('.vehicle__technical-data').css('height', 'auto');
    }

    $(window).resize(function () {
        updateVehicleSpecHeight();
    });

    $(document).on("change", ".vehicle-search__compare .js-trigger-select-change", function () {
        var form = $(".vehicle-search__compare:visible");
        $.post(form.data("filterroute"), form.serialize(), function (response) {
            var umbRouting = form.find("input[name=ufprt]").clone();
            form.html(response).append(umbRouting);
            form.find('.selectpicker').selectpicker('refresh');
        });
    });

    function updateComparedVehicles() {
        var form = $('#compare_form');
        $('.js-options-loader').fadeIn();
        $.ajax(
            {
                url: form.attr('action'),
                data: form.serialize(),
                type: "GET",
                success: function (data) {
                    $("#vehicle-results").html(data);
                    $('#js_mileage').val($('#AnnualMileage').val());
                    $('#js_contract').val($('#ContractTerm').val());
                    $('#js_initial').val($('#InitialRental').val());
                    $('#js_type').val($('.pt-cookie.is-active').text()); 
                    $('#js_vehicletype').val($('.vehicle-type-tabs').find('.btn.btn-filter.btn-xs:not(.btn-filter-inactive)').text());
                    updateVehicleSpecHeight();
                    $("html, body").animate({
                        scrollTop: $('.primary-filter-bar').offset().top - 75
                    }, 200);
                    $('.js-options-loader').fadeOut();
                }
            });
    };

    $(document).on('change', '#compare_form .selectpicker', function () {
        updateComparedVehicles();
        cookies.set("stp", $('.selectpicker[name="InitialRental"]').val() + '/' + $('.selectpicker[name="ContractTerm"]').val() + '/' + $('.selectpicker[name="AnnualMileage"]').val(), 30);
    });

    $(document).on('click', '.js-remove-vehicle-from-list', function (e) {
        e.preventDefault();

        var capID = $(this).closest('article').data('vehicle-cap-id');

        var cookiename = "compCar";
        if (cookies.get("vt") === "Vans") {
            cookiename = "compVan";
        }

        var cookieRemoveVal = cookies.get(cookiename).replace(capID, "");
        var value = cookieRemoveVal.replace(",,", ",").replace(/^,+|,+&/, "").replace(/,+$/, "").trim();
        cookies.set(cookiename, value, 30);
        var splitValue = value.split(",").filter(Boolean).length;

        if (splitValue < 4) {
            $('#vehicle-card-container-search').show();
        } else {
            $('#vehicle-card-container-search').hide();
        }
        if (splitValue < 1) {
            $('.col-lg-pull-8').hide();
            $('.col-lg-push-8').hide();
        }

        if (splitValue > 0) {
            $('#header .comparison-count').html(splitValue);
        } else {
            $('#header .comparison-count').html("");
        }

        if (splitValue === 1) {
            $('#compareLink').text("My Showroom");
        } else {
            $('#compareLink').text("My Showroom");
        }

        var form = $('#compare_form');
        $('.js-options-loader').fadeIn();
        $.ajax(
            {
                url: form.attr('action'),
                data: form.serialize(),
                type: "GET",
                success: function (data) {
                    $("#vehicle-results").html(data);
                    updateVehicleSpecHeight();
                    $("html, body").animate({
                        scrollTop: $('.primary-filter-bar').offset().top - 75
                    }, 200);
                    $('.js-options-loader').fadeOut();
                }
            });
    });

    $(document).on('click', '.js-popup-ajax', function (e) {
        e.preventDefault();

        var form = $('form[name="vehicle-payment"]:visible');
        var popupUrl = '/forms/confirm-multi-quote/';
        var virtualUrl = '/virtual/form-request/';
        
        $(this).magnificPopup({
            type: 'ajax',
            items: {
                src: popupUrl + '?' + form.serialize() +
                    "&PricingType=" + $('.pt-cookie.is-active').text() +
                    "&VehicleType=" + $('#js_vehicletype').val() +
                    "&Vehicles=" + $('input[name="Vehicles"]').val() +
                    "&AnnualMileage=" + $('#js_mileage').val() +
                    "&ContractTerm=" + $('#js_contract').val() +
                    "&InitialRental=" + $('#js_initial').val()
            },
            mainClass: "mfp-zoom-out mfp-fixed-xs",
            focus: 'input:first',
            removalDelay: 500,
            closeOnBgClick: false,
            callbacks: {
                ajaxContentAdded: function () {
                    placeholderFallback();
                    $('.js-validate-check').each(function () {
                        validFormField($(this));
                    });

                    ga(function (tracker) {
                        var clientID = tracker.get('clientId');
                        $("#form_analytics_id").val(clientID);
                    });

                    // send custom google analytics page view
                    ga('set', 'page', virtualUrl);
                    ga('send', 'pageview');

                    // send custom hotjar page view
                    hj('vpv', '/virtual/form/');
                    $("#form_enquiry_type").val("callback");
                }
            }
        }).magnificPopup('open');
    });

    $(document).on('submit', '#form-multi-quote-popup', function (e) {
        e.preventDefault();
        var form = $('#form-multi-quote-popup');
        var submit = form.find('button[type="submit"]');
        var currentText;

        if (submit.length) {
            currentText = submit.text();
            submit.text("Submitting...");
        } else {
            submit = form.find("input[type='submit']");
            currentText = submit.text();
            submit.val("Submitting...");
        }
        submit.attr("disabled", true);
        $.ajax({
            type: "POST",
            url: form.prop('action'),
            data: form.serializeArray(),
            success: function (data) {
                submit.removeAttr("disabled");
                if (submit.is("input")) {
                    submit.val(currentText);
                } else {
                    submit.text(currentText);
                }
                if (data.SaveSuccessful) {
                    form.find('.response-holder').html('<p class="alert alert-success" style="display: block;"><span class="icon_holder"><i class="icon-ok-sign"></i>' + data.SubmissionText + '</span></p>');
                    $('#request-a-quote-details').hide();
                    $('.row.fixed-pricing__ctas').hide();
                    setTimeout(function () {
                        window.location = $('#form-multi-quote-popup:visible').data('completeurl');
                    }, 1000);
                } else {
                    form.find('.response-holder').html('<p class="alert alert-danger" style="display: block;"><span class="icon_holder"><i class="icon-warning-sign"></i> There was an issue submitting your details. Please try again.</span></p>');
                }
            },
            error: function () {
                submit.removeAttr("disabled");
                if (submit.is("input")) {
                    submit.val(currentText);
                } else {
                    submit.text(currentText);
                }
            }
        });
    });

    var mileage = $('.js-mileage').val();

    if (mileage === "8000")
        $('.mileage-price').hide();
    else
        $('.mileage-price').show();


    $('.js-mileage').on('change', function (e) {
        var mileage = $('.js-mileage').val();
        if (mileage === "8000")
            $('.mileage-price').hide();
        else
            $('.mileage-price').show();
    });

    $(document).on('submit', '.send-comparison-form',
        function (e) {
            e.preventDefault();
            var form = $('.send-comparison-form');
            var submit = form.find('button[type="submit"]');
            submit.attr("disabled", true);
            form.find('.response-holder').html('');
            $.ajax({
                type: "POST",
                url: form.prop('action'),
                data: form.serializeArray(),
                success: function (data) {
                    submit.removeAttr("disabled");
                    if (data.SaveSuccessful) {
                        $('#compare-response').show();
                        $('#EmailAddress').val('');
                        form.find('.response-holder').html('<p class="alert alert-success" style="display: block;"><span class="icon_holder"><i class="icon-ok-sign"></i>' + data.SubmissionText + '</span></p>');
                    } else {
                        form.find('.response-holder').html('<p class="alert alert-danger" style="display: block;"><span class="icon_holder"><i class="icon-warning-sign"></i> There was an issue submitting your details. Please try again.</span></p>');
                    }
                    setTimeout(function () {
                        form.find('.response-holder').slideUp();
                        form.find('.response-holder').html('');                     
                    }, 3000);
                },
                error: function () {
                    submit.removeAttr("disabled");
                }
            });
        });

    //ga(function(tracker) {
    //	var clientID = tracker.get('clientId');
    //	$("#form_analytics_id").val(clientID);
    //});
});